// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class SecondaryNavigation extends WebComponent {
	constructor(element: HTMLElement, options: Object = {}) {
		super(element);

		this.options = {
			container: 'secondary-navigation__list',
			itemClass: 'secondary-navigation__item',
			linkClass: 'secondary-navigation__link',
			selector: '[data-navigation-id]',
			stickyOffset: 120, // Offset pro sticky menu
			...options
		};

		// Flags pro řízení scrollování při načítání stránky s kotvou
		this.isOurScrolling = false;
		this.blockingActive = false;
	}

	didMount() {
		this.buildNavigation();
		this.handleInitialAnchor();
	}

	buildNavigation() {
		// Najdeme všechny elementy s data-navigation-id
		const items = document.querySelectorAll(this.options.selector);
		const itemList = [];

		items.forEach(item => {
			const name = item.dataset.navigationName;
			const id = item.dataset.navigationId;

			if (name && id) {
				itemList.push({ name, id });
			}
		});

		// Vytvoříme HTML strukturu navigace
		const ul = document.createElement('ul');
		ul.className = this.options.container;

		itemList.forEach(item => {
			const li = document.createElement('li');
			li.className = this.options.itemClass;

			const link = document.createElement('a');
			link.className = this.options.linkClass;
			link.href = `${window.location.origin}${window.location.pathname}#${item.id}`;
			link.textContent = item.name;

			li.appendChild(link);
			ul.appendChild(li);
		});

		this.element.innerHTML = '';
		this.element.appendChild(ul);
	}

	// Zpracování kotvy při načtení stránky z jiné stránky
	handleInitialAnchor() {
		if (!window.location.hash) return;

		const targetId = window.location.hash.substring(1);
		const isOurAnchor = document.querySelector(`[data-navigation-id="${targetId}"]`);

		if (!isOurAnchor) return;

		// Zablokujeme nativní scrollování a počkáme na stabilizaci stránky
		this.preventNativeAnchorScroll();
		this.waitForPageLoad(() => {
			this.scrollToAnchor(targetId);
		});
	}

	// Blokuje nativní scrollování k hash fragmentům během načítání
	preventNativeAnchorScroll() {
		window.scrollTo(0, 0);
		this.blockingActive = true;

		let attempts = 0;
		const maxAttempts = 60; // 3 sekundy při 50ms intervalech

		const preventScroll = () => {
			if (this.isOurScrolling) {
				// Povolujeme náš vlastní scroll
			} else if (window.scrollY > 30) {
				window.scrollTo(0, 0);
			}

			attempts++;
			if (attempts < maxAttempts && this.blockingActive) {
				setTimeout(preventScroll, 50);
			} else {
				this.blockingActive = false;
			}
		};

		// Okamžité blokování + scroll event listener pro rychlou reakci
		preventScroll();

		const immediateBlock = (e) => {
			if (!this.isOurScrolling && this.blockingActive && window.scrollY > 1) {
				e.preventDefault();
				window.scrollTo(0, 0);
			}
		};

		window.addEventListener('scroll', immediateBlock, { passive: false });
		setTimeout(() => window.removeEventListener('scroll', immediateBlock), 3000);
	}

	// Čeká na plné načtení stránky včetně zdrojů
	waitForPageLoad(callback) {
		if (document.readyState === 'complete') {
			this.waitForElementStable(callback);
		} else {
			window.addEventListener('load', () => {
				this.waitForElementStable(callback);
			});
		}
	}

	// Čeká až se pozice cílového elementu stabilizuje
	waitForElementStable(callback) {
		const targetId = window.location.hash.substring(1);
		const targetElement = document.getElementById(targetId);

		if (!targetElement) {
			callback();
			return;
		}

		let lastPosition = targetElement.offsetTop;
		let stableCount = 0;
		const requiredStable = 3;

		const checkStability = () => {
			const currentPosition = targetElement.offsetTop;

			if (Math.abs(currentPosition - lastPosition) < 5) {
				stableCount++;
			} else {
				stableCount = 0;
			}

			lastPosition = currentPosition;

			if (stableCount >= requiredStable) {
				callback();
			} else {
				setTimeout(checkStability, 100);
			}
		};

		setTimeout(checkStability, 200);
	}

	// Provede přesné scrollování na kotvu s offsetem pro sticky menu
	scrollToAnchor(targetId) {
		const targetElement = document.getElementById(targetId);
		if (!targetElement) return;

		// Zastavíme blokování a označíme náš scroll
		this.blockingActive = false;
		this.isOurScrolling = true;

		// Použijeme stejnou logiku jako v web.js pro konzistenci
		const $targetElement = window.jQuery ? window.jQuery(`#${targetId}`) : null;
		let targetPosition;

		if ($targetElement && $targetElement.length) {
			// Použijeme jQuery offset() stejně jako v click handleru
			targetPosition = $targetElement.offset().top;
		} else {
			// Fallback pro případ že jQuery není dostupné
			targetPosition = targetElement.offsetTop;
		}

		// Použijeme offset z nastavení místo natvrdo zakódované hodnoty
		const offset = this.options.stickyOffset;

		const scrollToPosition = Math.max(0, Math.round(targetPosition - offset));

		// Použijeme okamžitý scroll místo smooth pro přesnější pozicování
		window.scrollTo(0, scrollToPosition);

		// Resetujeme flag po dokončení
		setTimeout(() => {
			this.isOurScrolling = false;
		}, 100);
	}

	// Metoda pro refresh navigace
	refresh() {
		this.buildNavigation();
	}
}



// WEBPACK FOOTER //
// ./fe/web-uhkPoint/src/js/components/SecondaryNavigation.js